// Generated by purs version 0.15.12
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Error_Class from "../Control.Monad.Error.Class/index.js";
import * as Control_Monad_Fork_Class from "../Control.Monad.Fork.Class/index.js";
import * as Control_Monad_Rec_Class from "../Control.Monad.Rec.Class/index.js";
import * as Data_Argonaut_Decode_Class from "../Data.Argonaut.Decode.Class/index.js";
import * as Data_Argonaut_Encode_Class from "../Data.Argonaut.Encode.Class/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Fusion_Data_FSError from "../Fusion.Data.FSError/index.js";
import * as Fusion_Data_Timestamp from "../Fusion.Data.Timestamp/index.js";
import * as Fusion_Generator from "../Fusion.Generator/index.js";
import * as Fusion_MonadWebsocket from "../Fusion.MonadWebsocket/index.js";
import * as MST_Data_EngineCommunication from "../MST.Data.EngineCommunication/index.js";
import * as MST_Data_StreamEvent from "../MST.Data.StreamEvent/index.js";
import * as MST_Data_Units from "../MST.Data.Units/index.js";
import * as Record from "../Record/index.js";
import * as WE_Class_AVar from "../WE.Class.AVar/index.js";
import * as WE_Class_MonadRef from "../WE.Class.MonadRef/index.js";
import * as WE_Class_Time from "../WE.Class.Time/index.js";
var $runtime_lazy = function (name, moduleName, init) {
    var state = 0;
    var val;
    return function (lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var merge = /* #__PURE__ */ Record.merge()();
var show = /* #__PURE__ */ Data_Show.show(Fusion_Data_FSError.showFSError);
var show1 = /* #__PURE__ */ Data_Show.show(Fusion_MonadWebsocket.showWsError);
var show2 = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
    reflectSymbol: function () {
        return "code";
    }
})(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil({
    reflectSymbol: function () {
        return "reason";
    }
})(Data_Show.showString))(Data_Show.showInt)));
var fromFoldable = /* #__PURE__ */ Data_Map_Internal.fromFoldable(MST_Data_Units.ordStreamId)(Data_Foldable.foldableArray);
var isFinal = /* #__PURE__ */ Fusion_Generator.isFinal(MST_Data_StreamEvent.isFinalStreamEventPayload);
var insert = /* #__PURE__ */ Data_Map_Internal.insert(MST_Data_Units.ordStreamId);
var $$delete = /* #__PURE__ */ Data_Map_Internal["delete"](MST_Data_Units.ordStreamId);
var lookup = /* #__PURE__ */ Data_Map_Internal.lookup(MST_Data_Units.ordStreamId);
var toUnfoldable = /* #__PURE__ */ Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray);
var startPingStream = function (dictMonadApp) {
    var MonadWebsockets5 = dictMonadApp.MonadWebsockets5();
    var Monad0 = MonadWebsockets5.Monad0();
    var Bind1 = Monad0.Bind1();
    var bind = Control_Bind.bind(Bind1);
    var discard1 = discard(Bind1);
    var MonadAppNE4 = dictMonadApp.MonadAppNE4();
    var fork = Control_Monad_Fork_Class.fork(MonadAppNE4.MonadFork0());
    var MonadBracket2 = dictMonadApp.MonadBracket2();
    var catchError = Control_Monad_Error_Class.catchError(MonadBracket2.MonadError1());
    var ManageAVar3 = MonadAppNE4.ManageAVar3();
    var empty = WE_Class_AVar.empty(ManageAVar3);
    var bracket = Control_Monad_Fork_Class.bracket(MonadBracket2);
    var createWs = Fusion_MonadWebsocket.createWs(MonadWebsockets5)(Data_Argonaut_Encode_Class.encodeJsonJString)(Data_Argonaut_Decode_Class.decodeJsonString);
    var put = WE_Class_AVar.put(ManageAVar3);
    var MonadTime2 = MonadAppNE4.MonadTime2();
    var now = WE_Class_Time.now(MonadTime2);
    var take = WE_Class_AVar.take(ManageAVar3);
    var pure = Control_Applicative.pure(Monad0.Applicative0());
    var delay = WE_Class_Time.delay(MonadTime2);
    var MonadKill3 = dictMonadApp.MonadKill3();
    var throwError = Control_Monad_Error_Class.throwError(MonadKill3.MonadThrow1());
    var kill_ = Fusion_Generator.kill_(MonadKill3);
    return function (v) {
        return function (v1) {
            return bind(v.ioStreamId.create)(function (streamId) {
                return discard1(v.emit(new MST_Data_EngineCommunication.Message({
                    message: new MST_Data_EngineCommunication.StartedPingStream(merge(v1)({
                        streamId: streamId
                    }))
                })))(function () {
                    return bind(fork(Data_Function.flip(catchError)(function (err) {
                        return discard1(v.emit(new MST_Data_EngineCommunication.Message({
                            message: new MST_Data_EngineCommunication.PerformedPing({
                                duration: new Data_Either.Left("WS error: " + show(err)),
                                streamId: streamId
                            })
                        })))(function () {
                            return v.emit(new MST_Data_EngineCommunication.Message({
                                message: new MST_Data_EngineCommunication.FinishedPingStream({
                                    streamId: streamId
                                })
                            }));
                        });
                    })(bind(empty)(function (avEvents) {
                        return bracket(createWs(v1.url)(function (ev) {
                            return put(ev)(avEvents);
                        }))(function (v2) {
                            return function (wsCommand) {
                                return wsCommand.close;
                            };
                        })(function (wsCommand) {
                            var loop = function (idx) {
                                return bind(now)(function (timestampStart) {
                                    return discard1(wsCommand.sendMessage("*"))(function () {
                                        return bind(take(avEvents))(function (event) {
                                            return bind(now)(function (timestampEnd) {
                                                if (event instanceof Fusion_MonadWebsocket.WsMessage && event.value0 === "*") {
                                                    var duration = Fusion_Data_Timestamp.diff(timestampEnd)(timestampStart);
                                                    return discard1(v.emit(new MST_Data_EngineCommunication.Message({
                                                        message: new MST_Data_EngineCommunication.PerformedPing({
                                                            duration: new Data_Either.Right(duration),
                                                            streamId: streamId
                                                        })
                                                    })))(function () {
                                                        if (v1.count instanceof Data_Maybe.Just && (v1.count.value0 - 1 | 0) === idx) {
                                                            return discard1(v.emit(new MST_Data_EngineCommunication.Message({
                                                                message: new MST_Data_EngineCommunication.FinishedPingStream({
                                                                    streamId: streamId
                                                                })
                                                            })))(function () {
                                                                return pure(Data_Unit.unit);
                                                            });
                                                        };
                                                        return discard1(delay(v1.interval))(function () {
                                                            return loop(idx + 1 | 0);
                                                        });
                                                    });
                                                };
                                                if (event instanceof Fusion_MonadWebsocket.WsMessage) {
                                                    return throwError(Fusion_Data_FSError.mk(Fusion_Data_FSError.PnRe50.value)("Websocket: Unexpected message"));
                                                };
                                                if (event instanceof Fusion_MonadWebsocket.WsError) {
                                                    return throwError(Fusion_Data_FSError.mk(Fusion_Data_FSError.PnCn51.value)("Websocket: Error: " + show1(event.value0)));
                                                };
                                                if (event instanceof Fusion_MonadWebsocket.WsClose) {
                                                    return throwError(Fusion_Data_FSError.mk(Fusion_Data_FSError.PnCn52.value)("Websocket: Closed, " + show2(event.value0)));
                                                };
                                                throw new Error("Failed pattern match at Fusion.EngineV2 (line 351, column 17 - line 377, column 95): " + [ event.constructor.name ]);
                                            });
                                        });
                                    });
                                });
                            };
                            return loop(0);
                        });
                    }))))(function (fiber) {
                        return v.ioCancellers.register(streamId)(kill_(fiber));
                    });
                });
            });
        };
    };
};
var mkSingletonBatch = function (streamId) {
    return function (streamEvent) {
        var batch = fromFoldable([ new Data_Tuple.Tuple(streamId, [ streamEvent ]) ]);
        return new MST_Data_EngineCommunication.Message({
            message: new MST_Data_EngineCommunication.NetworkReport({
                batch: batch
            })
        });
    };
};
var startDownloadStream = function (dictMonadApp) {
    var Monad0 = (dictMonadApp.MonadWebsockets5()).Monad0();
    var Bind1 = Monad0.Bind1();
    var bind = Control_Bind.bind(Bind1);
    var $$void = Data_Functor["void"]((Bind1.Apply0()).Functor0());
    var fork = Control_Monad_Fork_Class.fork((dictMonadApp.MonadAppNE4()).MonadFork0());
    var discard1 = discard(Bind1);
    var when = Control_Applicative.when(Monad0.Applicative0());
    var kill_ = Fusion_Generator.kill_(dictMonadApp.MonadKill3());
    return function (v) {
        return function (url) {
            return bind(v.ioStreamId.create)(function (v1) {
                var bufferedEmit = function (ev) {
                    return $$void(fork(v.emit(ev)));
                };
                return discard1(bufferedEmit(new MST_Data_EngineCommunication.Message({
                    message: new MST_Data_EngineCommunication.StartedDownloadStream({
                        streamId: v1,
                        url: url
                    })
                })))(function () {
                    return bind(v.mkDownloadStreamer(url))(function (streamer) {
                        return bind(fork((function () {
                            var $lazy_loop = $runtime_lazy("loop", "Fusion.EngineV2", function () {
                                return bind(Fusion_Generator.next(streamer))(function (ev) {
                                    return discard1(v.emit(mkSingletonBatch(v1)(ev)))(function () {
                                        return when(!isFinal(ev.payload))($lazy_loop(294));
                                    });
                                });
                            });
                            var loop = $lazy_loop(291);
                            return loop;
                        })()))(function (fiber) {
                            return v.ioCancellers.register(v1)(discard1(kill_(fiber))(function () {
                                return Fusion_Generator.cancel(streamer);
                            }));
                        });
                    });
                });
            });
        };
    };
};
var startUploadStream = function (dictMonadApp) {
    var Monad0 = (dictMonadApp.MonadWebsockets5()).Monad0();
    var Bind1 = Monad0.Bind1();
    var bind = Control_Bind.bind(Bind1);
    var $$void = Data_Functor["void"]((Bind1.Apply0()).Functor0());
    var fork = Control_Monad_Fork_Class.fork((dictMonadApp.MonadAppNE4()).MonadFork0());
    var discard1 = discard(Bind1);
    var when = Control_Applicative.when(Monad0.Applicative0());
    var kill_ = Fusion_Generator.kill_(dictMonadApp.MonadKill3());
    return function (v) {
        return function (byteCount) {
            return function (url) {
                return bind(v.ioStreamId.create)(function (v1) {
                    var bufferedEmit = function (ev) {
                        return $$void(fork(v.emit(ev)));
                    };
                    return discard1(bufferedEmit(new MST_Data_EngineCommunication.Message({
                        message: new MST_Data_EngineCommunication.StartedUploadStream({
                            streamId: v1,
                            url: url,
                            byteCount: byteCount
                        })
                    })))(function () {
                        return bind(v.mkUploadStreamer(byteCount)(url))(function (streamer) {
                            return bind(fork((function () {
                                var $lazy_loop = $runtime_lazy("loop", "Fusion.EngineV2", function () {
                                    return bind(Fusion_Generator.next(streamer))(function (ev) {
                                        return discard1(v.emit(mkSingletonBatch(v1)(ev)))(function () {
                                            return when(!isFinal(ev.payload))($lazy_loop(264));
                                        });
                                    });
                                });
                                var loop = $lazy_loop(261);
                                return loop;
                            })()))(function (fiber) {
                                return v.ioCancellers.register(v1)(discard1(kill_(fiber))(function () {
                                    return Fusion_Generator.cancel(streamer);
                                }));
                            });
                        });
                    });
                });
            };
        };
    };
};
var processCommand = function (dictMonadApp) {
    var startDownloadStream1 = startDownloadStream(dictMonadApp);
    var startUploadStream1 = startUploadStream(dictMonadApp);
    var startPingStream1 = startPingStream(dictMonadApp);
    var pure = Control_Applicative.pure(((dictMonadApp.MonadWebsockets5()).Monad0()).Applicative0());
    return function (v) {
        return function (v1) {
            if (v1 instanceof MST_Data_EngineCommunication.StartDownloadStream) {
                return startDownloadStream1({
                    emit: v.emit,
                    ioCancellers: v.ioCancellers,
                    ioStreamId: v.ioStreamId,
                    mkDownloadStreamer: v.mkDownloadStreamer
                })(v1.value0.url);
            };
            if (v1 instanceof MST_Data_EngineCommunication.StartUploadStream) {
                return startUploadStream1({
                    emit: v.emit,
                    ioCancellers: v.ioCancellers,
                    ioStreamId: v.ioStreamId,
                    mkUploadStreamer: v.mkUploadStreamer
                })(v1.value0.byteCount)(v1.value0.url);
            };
            if (v1 instanceof MST_Data_EngineCommunication.StartPingStream) {
                return startPingStream1({
                    emit: v.emit,
                    ioCancellers: v.ioCancellers,
                    ioStreamId: v.ioStreamId
                })(v1.value0);
            };
            if (v1 instanceof MST_Data_EngineCommunication.StartPingSyn) {
                return pure(Data_Unit.unit);
            };
            if (v1 instanceof MST_Data_EngineCommunication.StopStream) {
                return v.ioCancellers.runAndEmitAbort(v1.value0.streamId);
            };
            if (v1 instanceof MST_Data_EngineCommunication.StopStreams) {
                return v.ioCancellers.runAll(true);
            };
            if (v1 instanceof MST_Data_EngineCommunication.HealthCheck) {
                return v.emit(new MST_Data_EngineCommunication.Message({
                    message: new MST_Data_EngineCommunication.EngineInfo({
                        version: "0.0.1"
                    })
                }));
            };
            throw new Error("Failed pattern match at Fusion.EngineV2 (line 213, column 7 - line 238, column 70): " + [ v1.constructor.name ]);
        };
    };
};
var mkIOStreamId = function (dictMonadAppNE) {
    var Monad0 = (dictMonadAppNE.MonadRandom5()).Monad0();
    var MonadRef4 = dictMonadAppNE.MonadRef4();
    var modify = WE_Class_MonadRef.modify(MonadRef4);
    var pure = Control_Applicative.pure(Monad0.Applicative0());
    return Control_Bind.bind(Monad0.Bind1())(WE_Class_MonadRef["new"](MonadRef4)(0))(function (refStreamId) {
        var create = modify(refStreamId)(function (v) {
            return v + 1 | 0;
        });
        return pure({
            create: create
        });
    });
};
var mkIOCancellers = function (dictMonadAppNE) {
    var Monad0 = (dictMonadAppNE.MonadRandom5()).Monad0();
    var Bind1 = Monad0.Bind1();
    var bind = Control_Bind.bind(Bind1);
    var MonadRef4 = dictMonadAppNE.MonadRef4();
    var $$new = WE_Class_MonadRef["new"](MonadRef4);
    var modify_ = WE_Class_MonadRef.modify_(MonadRef4);
    var now = WE_Class_Time.now(dictMonadAppNE.MonadTime2());
    var discard1 = discard(Bind1);
    var Applicative0 = Monad0.Applicative0();
    var pure = Control_Applicative.pure(Applicative0);
    var read = WE_Class_MonadRef.read(MonadRef4);
    var for_ = Data_Foldable.for_(Applicative0);
    var for_1 = for_(Data_Foldable.foldableMaybe);
    var put = WE_Class_MonadRef.put(MonadRef4);
    var for_2 = for_(Data_Foldable.foldableArray);
    var when = Control_Applicative.when(Applicative0);
    return function (v) {
        return bind($$new(Data_Map_Internal.empty))(function (v1) {
            var register = function (streamId) {
                return function (canceller) {
                    return modify_(v1)(insert(streamId)(canceller));
                };
            };
            var emitAbort = function (streamId) {
                return bind(now)(function (timestamp) {
                    var abortEvent = {
                        timestamp: timestamp,
                        payload: MST_Data_StreamEvent.Abort.value
                    };
                    return discard1(v.emit(mkSingletonBatch(streamId)(abortEvent)))(function () {
                        return pure(Data_Unit.unit);
                    });
                });
            };
            var runAndEmitAbort = function (streamId) {
                return bind(read(v1))(function (v2) {
                    return discard1(modify_(v1)($$delete(streamId)))(function () {
                        return for_1(lookup(streamId)(v2))(function (canceller) {
                            return discard1(canceller)(function () {
                                return emitAbort(streamId);
                            });
                        });
                    });
                });
            };
            var runAll = function (shouldEmit) {
                return bind(read(v1))(function (v2) {
                    return discard1(put(v1)(Data_Map_Internal.empty))(function () {
                        return for_2(toUnfoldable(v2))(function (v3) {
                            return discard1(v3.value1)(function () {
                                return when(shouldEmit)(emitAbort(v3.value0));
                            });
                        });
                    });
                });
            };
            return pure({
                register: register,
                runAndEmitAbort: runAndEmitAbort,
                runAll: runAll
            });
        });
    };
};
var engineV2Connection = function (dictMonadApp) {
    var Monad0 = (dictMonadApp.MonadWebsockets5()).Monad0();
    var Bind1 = Monad0.Bind1();
    var bind = Control_Bind.bind(Bind1);
    var MonadAppNE4 = dictMonadApp.MonadAppNE4();
    var ManageAVar3 = MonadAppNE4.ManageAVar3();
    var empty = WE_Class_AVar.empty(ManageAVar3);
    var put = WE_Class_AVar.put(ManageAVar3);
    var $$void = Data_Functor["void"]((Bind1.Apply0()).Functor0());
    var fork = Control_Monad_Fork_Class.fork(MonadAppNE4.MonadFork0());
    var mkIOStreamId1 = mkIOStreamId(MonadAppNE4);
    var mkIOCancellers1 = mkIOCancellers(MonadAppNE4);
    var catchError = Control_Monad_Error_Class.catchError((dictMonadApp.MonadBracket2()).MonadError1());
    var forever = Control_Monad_Rec_Class.forever(MonadAppNE4.MonadRec1());
    var take = WE_Class_AVar.take(ManageAVar3);
    var processCommand1 = processCommand(dictMonadApp);
    var pure = Control_Applicative.pure(Monad0.Applicative0());
    var discard1 = discard(Bind1);
    var kill_ = Fusion_Generator.kill_(dictMonadApp.MonadKill3());
    return function (v) {
        return bind(empty)(function (emitAv) {
            return bind(empty)(function (commandQueueAv) {
                var emit = function (ev) {
                    return put(ev)(emitAv);
                };
                var bufferedEmit = function (ev) {
                    return $$void(fork(emit(ev)));
                };
                return bind(mkIOStreamId1)(function (v1) {
                    return bind(mkIOCancellers1({
                        emit: bufferedEmit
                    }))(function (v2) {
                        return bind(fork(Data_Function.flip(catchError)(function (err) {
                            return emit(new MST_Data_EngineCommunication.Message({
                                message: new MST_Data_EngineCommunication["Error"]({
                                    error: show(err)
                                })
                            }));
                        })(forever(bind(take(commandQueueAv))(function (command) {
                            return processCommand1({
                                emit: emit,
                                ioStreamId: v1,
                                ioCancellers: v2,
                                mkUploadStreamer: v.mkUploadStreamer,
                                mkDownloadStreamer: v.mkDownloadStreamer
                            })(command);
                        })))))(function (commandFiber) {
                            return pure({
                                cancel: discard1(kill_(commandFiber))(function () {
                                    return v2.runAll(false);
                                }),
                                connection: {
                                    send: function (engineCommand) {
                                        return $$void(fork(put(engineCommand)(commandQueueAv)));
                                    },
                                    recv: take(emitAv),
                                    engineType: MST_Data_EngineCommunication.Local.value
                                }
                            });
                        });
                    });
                });
            });
        });
    };
};
var mkEngineV2Interface = function (dictMonadApp) {
    var engineV2Connection1 = engineV2Connection(dictMonadApp);
    return function (cfg) {
        return {
            connectToEngine: engineV2Connection1(cfg)
        };
    };
};
export {
    engineV2Connection,
    mkEngineV2Interface
};
